module.exports = __webpack_public_path__ + "img/icon-top.6b0d2be9.svg";